module.exports = __webpack_public_path__ + "static/img/edit.e88f7f4b.svg";